// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2FJtT","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1shC3"};